import { render } from "./CustomerAliveDetailPage.vue?vue&type=template&id=34ba931a&scoped=true"
import script from "./CustomerAliveDetailPage.vue?vue&type=script&lang=js"
export * from "./CustomerAliveDetailPage.vue?vue&type=script&lang=js"

import "./CustomerAliveDetailPage.vue?vue&type=style&index=0&id=34ba931a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ba931a"]])

export default __exports__